<template>
  <div>
    <div class="auth-form__controls-wrapper">
      <div class="auth-form__controls">
        <validation-wrapper :issues="usernameValidationIssues">
          <template #default="{component, hasIssues}">
            <InputControl 
              v-model="username"
              class="auth-username-input"
              data-qa="auth-username-input"
              :theme="hasIssues ? 'error' : 'default'"
              size="max"
              :autofocus="true"
              :placeholder="$res.Views.Authorization_Username"
              @input="usernameValidationIssues = []"
            >
              <template #placeholder>
                {{ $res.Views.Authorization_Username }}
              </template>
              <template #end>
                <RenderNode :render-fn="component" />
              </template>
            </InputControl>
          </template>
        </validation-wrapper>
        <div class="auth-form__password-control">
          <validation-wrapper :issues="passwordValidationIssues">
            <template #default="{component, hasIssues}">
              <InputControl 
                v-model="password"
                class="auth-password-input"
                data-qa="auth-password-input"
                :theme="hasIssues ? 'error' : 'default'"
                size="max"
                :type="hiddenPassword ? 'password' : 'text'"
                :placeholder="$res.Views.Authorization_Password"
                @input="passwordValidationIssues = []"
              >
                <template #placeholder>
                  {{ $res.Views.Authorization_Password }}
                </template>
                <template #end>
                  <RenderNode :render-fn="component" />
                </template>
              </InputControl>
            </template>
          </validation-wrapper>
          <div v-if="forgotPasswordUrl">
            <a :href="forgotPasswordUrl">{{
                $res.Views.Authorization_ForgotPassword
              }}</a>
          </div>
        </div>
      </div>
      <div class="auth-form__actions">
        <base-button size="max" class="bn_submit" @click.prevent="onSubmitClicked" id="auth-submit-button" data-qa="auth-submit-button">
          {{ $res.Views.Authorization_Enter }}
        </base-button>
        <div v-if="registrationUrl" class="auth-form__register-link">
          <a :href="registrationUrl">{{ $res.Views.Authorization_Register }}</a>
        </div>
      </div>
      <div v-if="localServerErrors.length" class="auth-form__validation-issues">
        <inplace-validation-issues :issues="localServerErrors"></inplace-validation-issues>
      </div>
    </div>
    <div v-if="cooperationUrl" class="auth-form__bottom-panel">
      <div class="auth-form__partner" v-html="cooperationHtmlBlock"></div>
    </div>
  </div>
</template>

<script>
import Base from "./AuthorizationComponentBase";
import BaseButton from "@/common/controls/BaseButton.vue";
import InputControl from "@/common/controls/forms/input/InputControl.vue";
import RenderNode from "@/common/controls/util/RenderNode.vue";
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import ValidationWrapper from "@/common/ComponentValidationWrapper.vue";
import InplaceValidationIssues from "@/common/InplaceValidationIssues.vue";
import PasswordField from "./PasswordField.vue";

export default {
  mixins: [Base],
  components: {
    SvgIcon,
    BaseButton,
    RenderNode,
    InputControl,
    ValidationWrapper,
    InplaceValidationIssues,
    PasswordField,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.password-icon {
  color: var(--main-10);
  cursor: pointer;
  position: relative;
  top: -2px;
}

.password-icon--has-error {
  color: var(--system-10);
}

.auth-form__validation-issues {
  margin-top: -6px;
}

.auth-form__controls {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.auth-form__register-link {
  text-align: center;
  font-weight: 600;

  a {
    color: var(--btn-primary);
  }
}

.auth-form__controls-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 32px 20px 32px;
}

.auth-form__password-control {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.auth-form__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.auth-form__bottom-panel {
  padding: 20px 32px;
  background-color: var(--main-50);
}

.auth-form__partner {
  text-align: center;
  line-height: 20px;
}

:deep(.button.bn_submit) {
  width: 220px !important;
  margin: 0 auto;
}

.validation-summary-errors ul {
  list-style-type: none;
}

.validation-summary-errors li + li {
  margin-top: 4px;
}

.row.row_partner {
  background-color: var(--gray-150);
}
</style>
